(function (root) {
  const day = 86400000;
  function parse(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || '')) return null;
    const [y,m,d]=iso.split('-').map(Number);
    const value=new Date(Date.UTC(y,m-1,d));
    return value.getUTCFullYear()===y && value.getUTCMonth()===m-1 && value.getUTCDate()===d ? value : null;
  }
  function addMonths(date,months) {
    const first=new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth()+months,1));
    const last=new Date(Date.UTC(first.getUTCFullYear(),first.getUTCMonth()+1,0)).getUTCDate();
    first.setUTCDate(Math.min(date.getUTCDate(),last));
    return first;
  }
  function unit(n,singular,plural) {
    if(n===1)return singular;
    return `${n}${n%100>=20 || n%100===0?' de':''} ${plural}`;
  }
  function duration(target,today) {
    const end=parse(target),start=parse(today);
    if(!end || !start)return {state:'invalid',text:''};
    const totalDays=Math.round((end-start)/day);
    if(totalDays<0)return {state:'past',totalDays,text:''};
    if(totalDays===0)return {state:'today',totalDays,text:'astăzi'};
    if(totalDays<14)return {state:'future',totalDays,months:0,weeks:0,days:totalDays,text:unit(totalDays,'o zi','zile')};
    let months=(end.getUTCFullYear()-start.getUTCFullYear())*12+end.getUTCMonth()-start.getUTCMonth();
    if(addMonths(start,months)>end)months--;
    const remaining=Math.round((end-addMonths(start,months))/day),weeks=Math.floor(remaining/7),days=remaining%7;
    const parts=[];
    if(months)parts.push(unit(months,'o lună','luni'));
    if(weeks)parts.push(unit(weeks,'o săptămână','săptămâni'));
    if(days)parts.push(unit(days,'o zi','zile'));
    const text=parts.length<2?parts[0]:parts.slice(0,-1).join(', ')+' și '+parts.at(-1);
    return {state:'future',totalDays,months,weeks,days,text};
  }
  function todayInRomania(now=new Date()) {
    const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const get=(type)=>parts.find(p=>p.type===type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  }
  if(typeof module!=='undefined' && module.exports)module.exports={duration,todayInRomania};
  if(!root.customElements || root.customElements.get('mor-variant-delivery'))return;
  root.customElements.define('mor-variant-delivery',class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer=setInterval(()=>this.update(),60000);
      this.onVisible=()=>{if(!document.hidden)this.update()};
      document.addEventListener('visibilitychange',this.onVisible);
    }
    update() {
      const result=duration(this.dataset.date,todayInRomania());
      const active=result.state==='future'||result.state==='today';
      if(this.dataset.onlyActive==='true')this.hidden=!active;
      this.querySelector('[data-delivery-duration]').textContent=active?result.text:this.dataset.fallback;
      const date=this.querySelector('time');
      if(date)date.hidden=!active;
      const prefix=this.querySelector('[data-delivery-prefix]');
      if(prefix)prefix.hidden=result.state==='today'||(!active && this.dataset.keepPrefix!=='true');
      this.dataset.state=result.state;
    }
    disconnectedCallback() {clearInterval(this.timer);document.removeEventListener('visibilitychange',this.onVisible)}
  });
})(typeof window!=='undefined'?window:globalThis);
